import { Injectable } from '@angular/core';
import { StorageService } from './storage';

const keyUser = 'current-user';
const keyPublicId = 'public-id';
const guestUser = 'guest-user';

interface User {
    firstname: string;
    lastname: string;
    email: string;
    postalCode: string;
    profilePicture?: string;
}

@Injectable({
    providedIn: 'root'
})
export class UserService {
    public user: User;

    setUser(user: { firstname: string, lastname: string, email: string, postalCode: string, profilePicture?: string}) {
        this.user = {
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.email,
            postalCode: user.postalCode,
            profilePicture: user.profilePicture
        };
        StorageService.setStorage(keyUser, this.user);
    }

    setProfilePicture(imgId) {
        this.user.profilePicture = imgId;
        StorageService.setStorage(keyUser, {...this.user, profilePicture: imgId});
    }

    async setPublicIdUser(publicId: string) {
        await StorageService.setStorage(keyPublicId, publicId);
    }

    async setGuestUser(email: string) {
        await StorageService.setStorage(guestUser, email);
    }

    async deleteGuestUser() {
        await StorageService.removeStorage(guestUser);
    }

    async getGuestUser() {
        return await StorageService.getStorage(guestUser);
    }

    async getPrimaryInfosUser(): Promise<any> {
        if (!this.user) {
           return this.user = await StorageService.getStorage(keyUser);
        }
        return await this.user;
    }

    async getPublicIdUser(): Promise<string> {
        return await StorageService.getStorage(keyPublicId);
    }
}